import { useState } from "react";
import { BookOpen, Brain, FileText } from "lucide-react";
import { DocumentsTab, ExpertiseTab, GuidancesTab } from "./components";
import { useTranslation } from "react-i18next";

// Main Knowledge Base Component with Tabs
const KnowledgeBase = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<
    "documents" | "expertise" | "guidances"
  >("documents");

  return (
    <div>
      {/* Main Tabs */}
      <div className="mb-4 mt-2 flex w-full flex-col items-center border-b border-[#ececec] shadow-2xl shadow-white dark:border-navy-700 dark:!shadow-none xl:mb-3">
        <div className="flex w-full justify-start gap-11 overflow-hidden text-3xl">
          <button
            onClick={() => setActiveTab("documents")}
            className={`flex items-center gap-2 border-b-[4px] pb-3 hover:cursor-pointer ${
              activeTab === "documents"
                ? "border-brand-500 dark:border-brand-400"
                : "border-white dark:!border-navy-800"
            }`}
          >
            <FileText className="h-5 w-5" />
            <h5 className="text-base font-medium text-navy-700 dark:text-white">
              {t("library.documents")}
            </h5>
          </button>
          <button
            onClick={() => setActiveTab("expertise")}
            className={`flex items-center gap-2 border-b-[4px] pb-3 hover:cursor-pointer ${
              activeTab === "expertise"
                ? "border-brand-500 dark:border-brand-400"
                : "border-white dark:!border-navy-800"
            }`}
          >
            <Brain className="h-5 w-5" />
            <h5 className="text-base font-medium text-navy-700 dark:text-white">
              {t("library.expertise")}
            </h5>
          </button>
          <button
            onClick={() => setActiveTab("guidances")}
            className={`flex items-center gap-2 border-b-[4px] pb-3 hover:cursor-pointer ${
              activeTab === "guidances"
                ? "border-brand-500 dark:border-brand-400"
                : "border-white dark:!border-navy-800"
            }`}
          >
            <BookOpen className="h-5 w-5" />
            <h5 className="text-base font-medium text-navy-700 dark:text-white">
              {t("library.guidances")}
            </h5>
          </button>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === "documents" && <DocumentsTab />}
      {activeTab === "expertise" && <ExpertiseTab />}
      {activeTab === "guidances" && <GuidancesTab />}
    </div>
  );
};

export default KnowledgeBase;
